import {Helmet} from "react-helmet-async";
import {useSearchParams} from "react-router";

import {IncidentType} from "@/lib/types/statuspages.ts";
import {IncidentForm} from "@/pages/incidents/components/incident-edit/IncidentForm.tsx";

export const CreateIncidentPage = () => {
  const [searchParams] = useSearchParams();
  const statusPageId = searchParams.get("statusPageId");
  const incidentType = searchParams.get("incidentType") as IncidentType | null;
  const redirectTo = searchParams.get("redirectTo") || "/incidents";
  const disableStatusPageSelect = searchParams.get("disableStatusPageSelect") === "true";

  const defaultIncidentType = incidentType || IncidentType.INCIDENT;
  const title = defaultIncidentType === IncidentType.INCIDENT ? "Create Incident" : "Schedule Maintenance";

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <IncidentForm
        statusPageId={statusPageId ? parseInt(statusPageId) : undefined}
        defaultIncidentType={defaultIncidentType}
        redirectTo={redirectTo}
        disableStatusPageSelect={!!statusPageId && disableStatusPageSelect}
      />
    </>
  );
};
